// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from "@/views/index"
// /**
//  * 基础菜单
//  */
// // 商品管理
// import Goods from '@/views/goods/Goods';
// // 机器信息管理
// import Machine from '@/views/machine/Machine';
// // 货道信息管理
// import MachineAisle from '@/views/machine/MachineAisle';
// /**
//  * 订单管理
//  */
// // 交易订单
// import Order from '@/views/pay/Order';
// /**
//  * 系统管理
//  */
// // 用户管理
// import user from '@/views/system/user';
// // 菜单管理
// import Module from '@/views/system/Module';
// // 角色管理
// import Role from '@/views/system/Role';
// // 公司管理
// import Dept from '@/views/system/Dept';
// // 系统环境变量
// import Variable from '@/views/system/Variable';
// // 权限管理
// import Permission from '@/views/system/Permission';
// /**
//  * 支付管理
//  */
// // 支付配置信息
// import MachineConfig from '@/views/machine/MachineConfig';
// // 支付配置
// import Config from '@/views/pay/Config';
// /**
//  * 数据监控
//  */
// // 监控查询
// import druidLogin from '@/views/druid/login';

// // 图表界面
// import statistics from '@/views/charts/statistics';


import dataManage from "@/views/produceDataManage/index"

import printer from "@/views/printerManage"

import processManage from "@/views/processManage/index"

import accountManage from "@/views/userManage/index"

import history from "@/views/produceDataManage/history"

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        // component: login,
        redirect:"/index",
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, 
    {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
        {
            path: '/produceDataManage/index',
            name: '生产数据管理',
            component: dataManage,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/produceDataManage/history',
            name: '生产数据历史数据',
            component: history,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/printerManage/index',
            name: '打印管理',
            component: printer,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/processManage/index',
            name: '流程管理',
            component: processManage,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/accountManage/index',
            name: '账号管理',
            component:accountManage,
            meta: {
                requireAuth: true
            }
        }
    
    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js